import { useEffect } from "react";
import Logo from "./Logo";
import ContactForm from "./ContactForm";

function Bag01 ({ setBg, toppage }) {
    useEffect(() => {
        setBg('bg-bag01-m md:bg-bag01 md:bg-left-top');
        toppage.current?.scrollIntoView({behavior: 'smooth'});
    }, [setBg, toppage]);

    return (
        <div className="w-full flex flex-col">
            <div className="flex flex-row">
                <div className="md:w-1/3">
                    <div className="h-[280px] md:h-[130px]" />
                    <div className="md:mx-12 mx-6 mb-12">
                        <span className="align-middle font-goodtimes text-xl md:text-3xl px-5 py-2 text-primary-darker-yellow bg-primary-yellow leading-tight">BAGS</span>
                        <div className="font-goodtimes text-4xl mt-5 mb-3 md:text-5xl text-primary-yellow w-11/12">
                            <div>RAPID DEPLOY BULLETPROOF BACKPACK</div>
                        </div>
                        <hr />
                        <div className="text-primary-yellow mt-3">
                            <div>
                                THE PERFECT SOLUTION FOR PROFESSIONALS COMMITTED TO BEING PREPARED. WITH THE ABILITY TO TRANSFORM FROM A BACKPACK TO A BULLETPROOF VEST, WITH CUSTOMIZABLE AND REMOVABLE PANELS TO FIT ANY BODY TYPE, THIS PACK HAS MORE OPTIONS THAN EVER BEFORE.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="md:block hidden md:w-2/3 md:pl-96 md:pr-56 md:pt-24">
                    <Logo />
                </div>
            </div>
            <div className="bg-white flex flex-col md:flex-row md:justify-between md:bg-btmbg md:bg-contain md:bg-right-bottom">
                <div className="md:w-1/3">
                    <div className="text-[#9D9D9C] font-acier text-4xl pt-5 mx-6 md:ml-12">
                        FEATURES
                    </div>
                    <div className="bg-primary-yellow pb-5 mx-6 md:ml-12">
                        <ol className="list-decimal pl-8 pr-6 py-2">
                            <li>
                                Additional Armor Upgrades Include: Regular Aramid, Flexcore and Anti-Stab
                            </li>
                            <li>
                                Breathable mesh panels and channels to keep you cool.
                            </li>
                            <li>
                                Breathable mesh shoulder straps.
                            </li>
                            <li>
                                Approximately 35L / 2100 cubic inches.
                            </li>
                            <li>
                                Main compartment fits 11×14” armor or hydration pouch.
                            </li>
                            <li>
                                Compartment with places for pens, pistol and rifle magazines.
                            </li>
                            <li>
                                Lots of pockets and smaller compartments.
                            </li>
                            <li>
                                Armor made with Aramid in waterproof TPU outer cover.
                            </li>
                            <li>
                                Adjustable Shoulder and waist straps, waist belt, carry handle.
                            </li>
                            <li>
                                Cargo straps along the backpack bottom.
                            </li>
                        </ol>
                    </div>
                    <div className="mt-6 mx-16 md:mx-52 mb-8 grow">
                        <img className="h-auto w-[200%]" src={require('./assets/02-bag01-01.jpg')} alt="" draggable="false" />
                    </div>
                </div>

                <div className="md:w-1/3 mb-8">
                    <div className="text-black font-acier text-4xl pt-5 mx-6 md:ml-12">
                        TECH SPECS
                    </div>
                    <div className="mx-6 md:ml-12">
                        <div className="mt-3 font-bold">Convertable</div>
                        <div className="w-11/12">
                            BULLETPROOF BACKPACK THAT CONVERTS INTO PLATE CARRIER.
                        </div>
                        <div className="font-bold">Protection</div>
                        <div className="w-11/12">
                            ADDITIONAL ARMOR UPGRADES INCLUDE: REGULAR ARAMID, FLEXCORE AND ANTI-STAB
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row md:ml-6">
                        <div className="mx-16 my-6 md:mx-6">
                            <img className="h-auto w-[200%]" src={require('./assets/02-bag01-02.jpg')} alt="" draggable="false" />
                        </div>
                        <div className="mx-16 my-6 md:mx-6">
                            <img className="h-auto w-[200%]" src={require('./assets/02-bag01-03.jpg')} alt="" draggable="false" />
                        </div>
                    </div>
                </div>

                <div className="px-6 pb-12 md:w-1/3 md:px-12">
                    <ContactForm />
                </div>

            </div>
        </div>
    );
}

export default Bag01;
